'use client'

import FAQAccordion from '@/app/[locale]/(create)/components/FAQAccordion'
import { useConfigsContext } from '@/context/ConfigsContext'
import { Link } from '@/i18n/navigation'
import { motion } from 'framer-motion'
import { useTranslations } from 'next-intl'

function FAQ() {
  const { appConfig } = useConfigsContext()

  const { viverse_landing } = appConfig?.links || {}
  const viverseDomain = viverse_landing?.replace(/\/$/, '')
  const t = useTranslations()

  const faqs = [
    {
      question: t('partner.faq-question-1'),
      answer: t('partner.faq-answer-1'),
    },
    {
      question: t('partner.faq-question-2'),
      answer: t.rich('partner.faq-answer-2', {
        a: (chunks) => (
          <Link
            target="_blank"
            href={`${viverseDomain}/terms-of-use`}
            className="subheader-1 text-white hover:underline"
          >
            {chunks}
          </Link>
        ),
      }),
    },
    {
      question: t('partner.faq-question-3'),
      answer: t('partner.faq-answer-3'),
    },
    {
      question: t('partner.faq-question-4'),
      answer: t.rich('partner.faq-answer-4', {
        a: (chunks) => (
          <Link
            target="_blank"
            href="https://docs.viverse.com/monetization"
            className="subheader-1 text-white hover:underline"
          >
            {chunks}
          </Link>
        ),
      }),
    },
    {
      question: t('partner.faq-question-5'),
      answer: t('partner.faq-answer-5'),
    },
    {
      question: t('partner.faq-question-6'),
      answer: t('partner.faq-answer-6'),
    },
    {
      question: t('partner.faq-question-7'),
      answer: t('partner.faq-answer-7'),
    },
    {
      question: t('partner.faq-question-8'),
      answer: t('partner.faq-answer-8'),
    },
    {
      question: t('partner.faq-question-9'),
      answer: t.rich('partner.faq-answer-9', {
        a: (chunks) => (
          <Link
            target="_blank"
            href={`${viverseDomain}/terms-of-use`}
            className="subheader-1 text-white hover:underline"
          >
            {chunks}
          </Link>
        ),
      }),
    },
    {
      question: t('partner.faq-question-10'),
      answer: t.rich('partner.faq-answer-10', {
        a: (chunks) => (
          <Link
            target="_blank"
            href={`${viverseDomain}/terms-of-use`}
            className="subheader-1 text-white hover:underline"
          >
            {chunks}
          </Link>
        ),
      }),
    },
  ]

  return (
    <section className="3xl:px-[120px] relative flex flex-1 flex-col items-center justify-center gap-12 px-4 py-8 md:gap-20 md:px-10 lg:px-20 lg:pt-[120px] lg:pb-12">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.8, ease: 'easeOut' }}
        className="md:header-2 header-3 inline w-full text-center"
      >
        <span>
          {t.rich('partner.faq.title', {
            highlight: (chunks) => <span className="text-primary">{chunks}</span>,
          })}
        </span>
      </motion.div>

      <div className="relative grid w-full place-items-center lg:max-w-[70%]">
        <div className="flex w-full flex-1 flex-col gap-4">
          {faqs.map((faq, i) => (
            <motion.div
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.6, ease: 'easeOut' }}
              key={faq.question}
            >
              <FAQAccordion index={i} {...faq} />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default FAQ
